<div class="pagination-bar-container" data-pagination-bar>
  <div class="results">
    <span data-first-row-displayed [innerText]="firstRowDisplayed | number"></span>
    <span>-</span>
    <span data-last-row-displayed [innerText]="lastRowDisplayed | number"></span>
    <span data-total-results [innerText]="' of ' + (rowCount | number) + ' results'"></span>
  </div>

  <div class="pages">
    <select [formControl]="pageDropdown" (change)="onPageChange()" data-page-dropdown>
      @for (page of pageOptions; track page) {
        <option [value]="page" [innerText]="page"></option>
      }
    </select>
    <span data-total-pages [innerText]="' of ' + (totalPages | number)"></span>
  </div>

  <div class="navigate">
    <a
      data-previous
      (click)="onPrevious()"
      [ngClass]="{ disabled: currentPage <= 1 }"
      [attr.disabled]="currentPage <= 1 ? '' : null">
      <em class="sch-chevron-left nav"></em>&nbsp;Prev
    </a>
    <span class="pipe">&ensp;|&ensp;</span>
    <a
      data-next
      (click)="onNext()"
      [ngClass]="{ disabled: currentPage >= totalPages }"
      [attr.disabled]="currentPage >= totalPages ? '' : null">
      Next&nbsp;<em class="sch-chevron-right nav"></em>
    </a>
  </div>
</div>
